<template>

  <div class="order-summary md:order-summary relative">

    <div class="p-6 md:p-8">

      <!-- Header -->
      <div class="title">{{ $t('advertisers_fund.order_summary.title') }}</div>
      <vs-divider class="mb-6"></vs-divider>
      <div>
        <!-- Input Amount -->
        <div class="flex items-baseline mb-4">
          <div class="w-1/2 amount-label">{{ $t('advertisers_fund.order_summary.amount') }}</div>
          <div class="w-1/2 flex justify-end">
            <div class="amount md:amount">{{ (amount || 0) | addComma('$') }}</div>
          </div>
        </div>

        <!-- Dicscount -->
        <div v-if="discount > 0" class="flex items-baseline mb-4">
          <div class="w-1/2 amount-label discount">{{ $t('advertisers_fund.order_summary.discount') }}</div>
          <div class="w-1/2 flex justify-end">
            <div class="amount md:amount discount">{{ discount | addComma('$') }}</div>
          </div>
        </div>

        <!-- Sub Total -->
        <div class="flex items-baseline mb-6">
          <div class="w-1/2 amount-label">{{ $t('advertisers_fund.order_summary.sub_total') }}</div>
          <div class="w-1/2 flex justify-end">
            <div class="amount md:amount">{{ (subTotal || 0) | addComma('$') }}</div>
          </div>
        </div>
      </div>

      <!-- Fees -->
      <div class="flex items-baseline mb-6">
        <div class="w-12 mr-4 amount-label">{{ $t('advertisers_fund.order_summary.fees') }}</div>
        <div class="w-20 fees text-speakol-color">
          {{ paymentFees.value }}{{ paymentFees.type === 'PERCENTAGE' ? '%' : '+' }}
        </div>
        <div class="w-full flex justify-end">
          <div class="amount md:amount">{{ (fees || 0) | addComma('$') }}</div>
        </div>
      </div>

      <!-- VAT -->
      <div v-if="vatEnabled" class="flex items-baseline">
        <div class="w-12 mr-4 amount-label">{{ $t('advertisers_fund.order_summary.vat') }}</div>
        <div class="w-12 fees">{{ (vatValue || 0) | addComma('%') }}</div>
        <div class="w-full flex justify-end">
          <div class="amount md:amount">{{ (vat || 0) | addComma('$')  }}</div>
        </div>
      </div>
    </div>

    <footer class="order-summary-footer p-4 w-full md:px-8 md:py-4">
      <div class="flex items-baseline mb-2">
        <div class="w-1/2 amount-total-label md:amount-total-label">{{ $t('advertisers_fund.order_summary.paid_amount') }}</div>
        <div class="w-1/2 flex justify-end">
          <div class="amount-total md:amount-total">{{ total | addComma('$') }}</div>
        </div>
      </div>

      <div v-if="bonus > 0" class="flex items-baseline">
        <div class="w-1/2 balance-amount-label bonus pb-2">{{ $t('advertisers_fund.order_summary.bonus') }}</div>
        <div class="w-1/2 flex justify-end">
          <div class="balance-amount md:balance-amount">{{ bonus | addComma('$') }}</div>
        </div>
      </div>

      <div class="flex items-baseline">
        <div class="w-1/2 balance-amount-label">{{ $t('advertisers_fund.order_summary.amount_added_to_balance_label') }}</div>
        <div class="w-1/2 flex justify-end">
          <div class="balance-amount md:balance-amount">{{ balance | addComma('$') }}</div>
        </div>
      </div>
    </footer>

  </div>

</template>


<script>
const PERCENTAGE = 'PERCENTAGE'

export default {
  props: ['amount', 'vatEnabled', 'paymentMethod'],
  data () {
    return {
      account: this.$store.getters['authentication/activeAccount'],
      // TODO: get values from database
      feesTable: {
        'Stripe': {
          type: PERCENTAGE,
          value: 3
        },
        'Paytabs': {
          type: PERCENTAGE,
          value: 2.7
        },
        'Paypal': {
          type: PERCENTAGE,
          value: 5
        },
        'Checkout': {
          type: PERCENTAGE,
          value: 3
        }
      }
    }
  },

  computed: {
    paymentFees () {
      return this.feesTable[this.paymentMethod] ? this.feesTable[this.paymentMethod] : this.feesTable['stripe']
    },

    subTotal () {
      if (this.discount > 0) {
        return (this.amount - this.discount)
      }

      return this.amount || 0
    },

    fees () {
      const currentPaymentFees = this.paymentFees
      if (currentPaymentFees.type === PERCENTAGE) {
        return (this.percentage(this.subTotal, currentPaymentFees.value)).toFixed(2)
      } else {
        return (currentPaymentFees.value).toFixed(2)
      }
    },

    vatValue () {
      return this.account['actual_vat_percentage'] || 0
    },

    vat () {
      if (!this.vatEnabled) {
        return 0
      }

      return (parseFloat(this.total) - (parseFloat(this.total) / ((100 + parseFloat(this.vatValue)) / 100))).toFixed(2)
    },

    total () {
      return (parseFloat(this.subTotal) + parseFloat(this.fees)).toFixed(2)
    },

    balance () {
      const amountAfterVat = parseFloat(this.subTotal) + parseFloat(this.vat)
      let balance = this.subTotal

      if (this.bonus > 0) {
        balance = amountAfterVat + this.bonus
      } else if (this.discount > 0) {
        balance = amountAfterVat + this.discount
      }

      return parseFloat(balance)
    },

    bonus () {
      if (this.account && this.account.bonus_type === this.$constants.BONUS_TYPES.BONUS) {
        return parseFloat(this.amount * this.bonusPercentage / 100)
      }

      return 0
    },

    discount () {
      if (this.account && this.account.bonus_type === this.$constants.BONUS_TYPES.DISCOUNT) {
        return parseFloat(this.amount * this.bonusPercentage / 100)
      }

      return 0
    },

    bonusPercentage () {
      return parseFloat(window._.get(this.account, 'bonus_percentage', 0))
    }
  },
  methods: {
    percentage (totalValue, partialValue) {
      return Math.round((totalValue * partialValue / 100) * 100) / 100
    }
  }
}
</script>

<!--suppress CssInvalidAtRule -->
<style lang="scss" scoped>
$summary-background-color: white;
$summary-footer-background-color: rgba(0, 146, 215, 0.06);
$summary-order-border-color: #f2f2f2;
$dark-gray: #2c2c2c;
$discount-red-color: #db2828;
$success-green-color: #21ba45;

.custom-font-appearance {
  font-style: normal;
  font-weight: 500;
  color: $dark-gray;
}

.normal-font-appearance {
  font-style: normal;
  font-weight: normal;
}

.order-summary {
  background: $summary-background-color;
  border: 1px solid $summary-order-border-color;
  border-radius: 15px;
  min-height: 300px;
}

.order-summary-footer {
  background: $summary-footer-background-color;
  border-radius: 1px 1px 15px 15px;
  position: absolute !important;
  bottom: 0;
}

.amount-label {
  @extend .normal-font-appearance;

  font-size: 14px;
  line-height: 21px;
  color: $dark-gray;
}

.fees {
  @extend .normal-font-appearance;

  font-size: 13px;
  line-height: 19px;
}

.amount-total-label,
.amount,
.amount-total {
  @extend .custom-font-appearance;

  font-size: 16px;
  line-height: 24px;
}

.balance-amount-label,
.balance-amount {
  @extend .normal-font-appearance;

  font-size: 12px;
  line-height: 18px;
  color: $dark-gray;

  @apply whitespace-no-wrap;
}

.title {
  @extend .custom-font-appearance;

  font-size: 24px;
  line-height: 24px;
}

.bonus {
  color: $success-green-color !important;
}

.discount {
  @extend .normal-font-appearance;

  color: $discount-red-color !important;
}
</style>
